import { Box, Grid, styled } from '../../base';

export const StyledSaveJobContainer = styled(Grid)(() => ({
    padding: '43px 38px 50px 38px',
}));

export const StyledSaveJobBox = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.common.white,
    minHeight: '700px',
    borderRadius: '15px',
    position: 'relative',
    padding: '20px 32px 32px 32px',
}));

export const StyledStepperWrap = styled(Grid)(({}) => ({
    position: 'absolute',
    insetInlineStart: '-20px',
    top: '60px',
}));
